import React, {FC, useState} from "react";
import Address from "../../types/address";
import Button from "../button";
import useValidatedAddresses from "../../hooks/use-validated-addresses";
import AddressCard from "../address-card";
import {cleanPostalCode} from "../../lib/address-util";

const AddressValidation: FC<{
  address: Address,
  updateAddress: (a: Address) => void,
  onComplete?: () => void
}> = ({
        address,
        updateAddress,
        onComplete = () => {
        }
      }) => {
  const [originalAddress, setOriginalAddress] = useState(address);
  const [selectedAddress, setSelectedAddress] = useState(address);
  const [validatedAddresses, setValidatedAddresses] = useState<Address[] | undefined>();

  const isSelected = (a: Address) => {
    return selectedAddress.address1 === a.address1 &&
      selectedAddress.state === a.state &&
      selectedAddress.postalCode === a.postalCode &&
      selectedAddress.country === a.country;
  }

  const currentValidatedAddress = () => {
    // Current inputted address not the same as the current address that was just validated.
    // For some reason, when you try to validate an address that was just validated it'll hang.
    return originalAddress &&
      originalAddress.address1 === address.address1 &&
      originalAddress.city === address.city &&
      originalAddress.state === address.state &&
      originalAddress.postalCode === address.postalCode &&
      originalAddress.country === address.country;
  }

  const [isValidating, setIsValidating] = useState<boolean>(false);
  const [getValidatedAddresses] = useValidatedAddresses((data) => {
    setIsValidating(false);
    setOriginalAddress(address);

    let validatedAddresses = data.validatedAddresses
      ? data.validatedAddresses
        .map((va: Address) => {
          let vaUpdated = { ...va };
          vaUpdated.postalCode = cleanPostalCode(vaUpdated);
          return vaUpdated;
        })
      : [];

    if (validatedAddresses && validatedAddresses.length > 0) {
      setSelectedAddress(validatedAddresses[0]);
    }

    setValidatedAddresses(validatedAddresses);

    onComplete();
  });

  const onClick = () => {
    setIsValidating(true);
    getValidatedAddresses(address);
  }

  const onSelect = (sa: Address) => {
    setSelectedAddress(sa);
  }

  return (<div style={{ marginBottom: "15px" }}>
    {
      (address.country
        && address.state
        && address.city
        && address.postalCode
        && address.address1
        && !currentValidatedAddress()) &&
      <Button text="Validate Address" disabled={isValidating} onClick={onClick}/>
    }
    {
      validatedAddresses &&
      <>
        {
          validatedAddresses.length > 0
            ? <>
              <p>Please choose address to use:</p>
              {
                validatedAddresses.map((va: Address, index: number) => {
                  const vaUpdated = { ...originalAddress };
                  vaUpdated.country = va.country;
                  vaUpdated.state = va.state;
                  vaUpdated.city = va.city;
                  vaUpdated.postalCode = va.postalCode;
                  vaUpdated.address1 = va.address1;
                  vaUpdated.address2 = va.address2;

                  return <AddressCard address={vaUpdated}
                                      selected={isSelected(vaUpdated)}
                                      onSelect={onSelect}
                                      key={index}/>
                })
              }
              <Button text="Use" onClick={(e) => {
                e.preventDefault();
                updateAddress(selectedAddress);
                setValidatedAddresses(undefined);
                setOriginalAddress(selectedAddress);
              }}/>
            </>
            : <>
              <p>No validated addresses found.</p>
            </>
        }
      </>
    }
  </div>)
}

export default AddressValidation;
